import Vue from 'vue';
import Router from 'vue-router';

import home from '@/views/home/home.router';
import project from '@/views/project/project.router';
import monitor from '@/views/error-monitor/monitor.router';
import workItem from '@/views/work-item/work-item.router';
import directives from '@/views/directives/directives.router';
import TaskReport from '@/views/task/task-report.view.vue';
import MandalaReport from '@/views/mandala-report/mandala-report.view.vue';
import Token from '@/views/token.view.vue';
import Survey from '@/views/survey/survey.view.vue';
import LoginComponent from '@/views/login/login.component.vue';
import CallbackComponent from '@/views/login/callback.component.vue';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/horas',
      name: 'Relatório de horas Task x Ponto',
      component: TaskReport,
    },
    ...home,
    ...project,
    ...monitor,
    ...workItem,
    ...directives,
    {
      path: '/token',
      name: 'token',
      component: Token,
    },
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/pesquisa-satisfacao',
      name: 'Pesquisa de Satisfação',
      component: Survey,
    },
    {
      path: '/mandala-report',
      name: 'Dashboard',
      component: MandalaReport,
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent,
      meta: {
        requiresAuth: false,
        hideMenus: true,
      },
    },
    {
      path: '/callback',
      name: 'Callback',
      component: CallbackComponent,
      meta: {
        requiresAuth: false,
        hideMenus: true,
      },
    },
  ],
});


router.beforeEach((to: any, from: any, next: any) => {
  const requiredAuth = to.meta.requiresAuth === undefined ? true : to.meta.requiresAuth;
  const { token } = store.state;
  const isPublic = to.path.includes('/public') || !requiredAuth;
  if (isPublic) {
    next();
  }
  if (to.path.includes('/login') && token) {
    next('/');
  }
  if (!token && !isPublic) {
    localStorage.setItem('redirectAfterLogin', to.path);
    next('/login');
  }
  next();
});

export default router;
